import './canvases.css';

/**
 * This is the component wrapper for the canvases. The canvases will be injected into the #canvases element.
 */
export default function Canvases() {
    return <div id='canvases' />;
}
